<template>
	<component v-if="component" :is="component" :payload="payload" />
	<router-view v-else />
</template>


<script>
	export default {
		name: 'app-view',
		data() {
			return {
				component: false,
				payload: null
			};
		},
		watch: {
			$route() {
				this.component = false;
			}
		},
		created() {
			window.eventBus.$on('error-page', (component, payload) => {
				this.component = component;
				this.payload = payload;
			});
		},
	};
</script>